import { parseContentItems } from 'components/production/components/AisleContent/utils';

/**
 * Transforms a saved banner carousel from the database into the form data
 * structure. The API stores items as a JSON string in `contentItems`; the
 * form components expect a plain `items` array.
 *
 * @param {Object} banner - Raw banner object from the API.
 * @returns {Object} Form-compatible data.
 */
export function transformBannerCarouselToFormData(banner) {
    const parsed = parseContentItems(banner.contentItems);
    const items = Array.isArray(parsed) ? parsed : [];

    return {
        displayType: banner.displayType,
        id: banner.id,
        items,
        name: banner.bannerName || '',
    };
}

/**
 * Builds the payload for the aisle banner API from the banner carousel form
 * data. The items array is serialised into the `contentItems` field.
 *
 * @param {string} aisleID - Parent aisle ID.
 * @param {Object} formData - Banner carousel form data.
 * @returns {Object} API payload.
 */
export function buildBannerCarouselPayload(aisleID, formData) {
    return {
        aisleID,
        bannerName: formData.name,
        contentItems: JSON.stringify(formData.items),
        displayType: formData.displayType,
    };
}
